import { useState } from 'react';

// graphql
import { PageInfo, useAdt_CashierCashTransfersQuery, useCashierConfirmCashTransferMutation } from '@/generated/graphql';

// components
import { TableCashierCashTransfers } from './table';
import { IModalConfirmationDetails, ConfirmationModal } from '@/components/modal/confirmation';

// interfaces
import { ICashierCashTransferQueryVariable, ICashierCashTransferTable, mapGQLCashierCashTransfer } from '@/shared/interfaces';

interface IProps {
  refetch: () => void;
}

export const CashTransfers = ({ refetch }: IProps) => {
  const [cashierCashTransfers, setCashierCashTransfers] = useState<ICashierCashTransferTable[]>([]);

  const [cashierCashTransfer, setCashierCashTransfer] = useState<ICashierCashTransferTable | undefined>();

  const [confirmationModal, setConfirmationModal] = useState<IModalConfirmationDetails>({
    isOpen: false,
    title: 'Are you sure ?',
    messages: ['You want to confirm this transaction'],
  });

  const [cashierCashTransfersQueryVariable, setCashierCashTransfersQueryVariable] = useState<ICashierCashTransferQueryVariable>({
    first: 25,
  });

  const [cashierCashTransfersPageInfo, setCashierCashTransfersPageInfo] = useState<PageInfo>();
  const [cashierCashTransfersTotalCount, setCashierCashTransfersTotalCount] = useState<number>(0);

  const [cashierConfirmCashTransfer] = useCashierConfirmCashTransferMutation();

  const cashierCashTransfersQuery = useAdt_CashierCashTransfersQuery({
    variables: cashierCashTransfersQueryVariable,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      const mappedData = data.cashierCashTransfers.nodes.map((x) => mapGQLCashierCashTransfer(x));

      const mappedTableData: ICashierCashTransferTable[] = mappedData.map((x) => ({
        id: x.id,
        amount: x.amount,
        status: x.status,
        cashierUsername: x.cashier.user.username,
        adminUsername: x.admin.user.username,
        createdAt: x.createdAt,
      }));

      setTimeout(() => {
        setCashierCashTransfers(mappedTableData);
        setCashierCashTransfersPageInfo(data.cashierCashTransfers.pageInfo);
        setCashierCashTransfersTotalCount(data.cashierCashTransfers.totalCount);
      }, 100);
    },
  });

  const transactionAction = (actionType: string, data: ICashierCashTransferTable) => {
    switch (actionType) {
      case 'confirm':
        setCashierCashTransfer(data);
        setConfirmationModal((prev) => ({ ...prev, isOpen: true }));
        break;
      default:
        break;
    }
  };

  const confirmTransaction = () => {
    console.log(cashierCashTransfer);
    if (cashierCashTransfer) {
      setConfirmationModal((prev) => ({ ...prev, isOpen: false }));
      cashierConfirmCashTransfer({
        variables: {
          cashierConfirmCashTransferId: cashierCashTransfer.id,
        },
        onCompleted: () => {
          cashierCashTransfersQuery.refetch();
          refetch();
        },
      });
    }
  };

  return (
    <>
      <TableCashierCashTransfers
        rows={cashierCashTransfers}
        setCashierCashTransferQueryVariable={setCashierCashTransfersQueryVariable}
        cashierCashTransferQueryVariable={cashierCashTransfersQueryVariable}
        totalCount={cashierCashTransfersTotalCount}
        pageInfo={cashierCashTransfersPageInfo}
        getCashierCashTransferLoading={cashierCashTransfersQuery.loading}
        transactionAction={transactionAction}
      />
      <ConfirmationModal
        modalDetails={confirmationModal}
        setModalDetails={setConfirmationModal}
        confirm={confirmTransaction}
        confirmText={'confirm'}
      />
    </>
  );
};
